import { Button, Modal } from "react-bootstrap";

export default function ConfirmDeleteElementDialog({ show, onClose, onConfirm, message }) {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Potwierdz usuniecie</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message ?? "Czy usunac element?"}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Anuluj
        </Button>
        <Button
          variant="danger"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          Usun
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
